"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormModal = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

require("./index.less");

var _formView = require("../formView");

var _locale = require("../locale");

var _jsonComponent = require("../common/jsonComponent");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormModal = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    FormView: _formView.FormView
  }
}), _dec2 = (0, _vuePropertyDecorator.Model)('change'), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return {};
  }
}), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: 'add'
}), _dec5 = (0, _vuePropertyDecorator.Prop)(), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(FormModal, _Mixins);

  var _super = _createSuper(FormModal);

  function FormModal() {
    var _this;

    (0, _classCallCheck2.default)(this, FormModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "visible", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "mode", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "handleSubmit", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "title", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    _this.loading = false;
    return _this;
  }

  (0, _createClass2.default)(FormModal, [{
    key: "factTitle",
    get: function get() {
      if (this.title) {
        return this.title;
      }

      var obj = this.formProperty;
      return obj && ((0, _locale.getLang)() === 'zh' ? obj.name : obj.enName) || '';
    }
  }, {
    key: "doSubmit",
    value: function doSubmit() {
      var _this$$refs$form, _this$$refs$form$doSu;

      (_this$$refs$form = this.$refs.form) === null || _this$$refs$form === void 0 ? void 0 : (_this$$refs$form$doSu = _this$$refs$form.doSubmit) === null || _this$$refs$form$doSu === void 0 ? void 0 : _this$$refs$form$doSu.call(_this$$refs$form);
    }
  }, {
    key: "onOk",
    value: function onOk() {
      this.doSubmit();
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.$emit('change', false);
      this.$emit('cancel', false);
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this2 = this;

      var visible = this.visible,
          data = this.data,
          mode = this.mode,
          onOk = this.onOk,
          loading = this.loading,
          handleSubmit = this.handleSubmit,
          factTitle = this.factTitle,
          onCancel = this.onCancel;
      var actions = this.$slots.actions; // 加上 loading 效果

      var doWithSubmit = /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2.loading = true;
                  _context.prev = 1;
                  _context.next = 4;
                  return handleSubmit(values);

                case 4:
                  _this2.$emit('change', false);

                  _context.next = 9;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](1);

                case 9:
                  _context.prev = 9;
                  _this2.loading = false;
                  return _context.finish(9);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 7, 9, 12]]);
        }));

        return function doWithSubmit(_x) {
          return _ref.apply(this, arguments);
        };
      }();

      return h("a-modal", {
        "attrs": {
          "visible": visible,
          "title": factTitle,
          "okButtonProps": {
            props: {
              loading: loading
            }
          },
          "footer": mode === 'view' ? null : undefined,
          "maskClosable": false,
          "width": 600,
          "centered": true,
          "destroyOnClose": true
        },
        "on": {
          "ok": onOk,
          "cancel": onCancel
        }
      }, [h("div", {
        "ref": "container",
        "style": "position: relative;"
      }, [mode === 'view' && actions && h("div", {
        "class": "form-modal-actions"
      }, [actions]), h("form-view", {
        "class": "form-modal",
        "attrs": {
          "mode": mode,
          "data": data,
          "json": this.privateJson || this.json,
          "handleSubmit": doWithSubmit,
          "filterType": this.filterType
        },
        "key": (data._id || '-1') + mode,
        "ref": "form"
      })])]);
    }
  }]);
  return FormModal;
}((0, _vuePropertyDecorator.Mixins)(_jsonComponent.JsonComponent)), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "visible", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "data", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "mode", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "handleSubmit", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "title", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.FormModal = FormModal;